<template>
<div>
  <v-layout>
    <div class="flex md6">
      <v-select ref="paraedit" :items="items" :rules="rules" v-model="paraBirimi" item-value="text" item-text="text" :label="$t('Currency-Unit')" hide-details v-on:input="paraBirimiChange()"></v-select>
    </div>
    <div class="flex md6">

      <v-text-field ref="kuredit" hide-details :label="$t('Exchange-Rate-v2')" :rules="rules"  v-model="kur" v-on:change="kurChange()">
      </v-text-field>
    </div>

  </v-layout>

</div>
</template>

<script>
import tool from "../tools";

var store = {
  debug: true,
  okunuyor: false,
  state: {
    paraBirimleri: []
  },
  setParaBirimleri(newValue) {

    this.state.paraBirimleri = newValue;
  }
};

export default {
  components: {},
  props: ["value", "kurtarihi","rules"],

  computed: {
    model: {
      get: function () {
        this.watchmodel(this.value);
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      }
    }
  },
  data() {
    return {
      items: [],
      defitems: [{
          text: "TL"
        },
        {
          text: "USD"
        },
        {
          text: "AUD"
        },
        {
          text: "DKK"
        },
        {
          text: "EUR"
        },
        {
          text: "GBP"
        },
        {
          text: "CHF"
        },
        {
          text: "SEK"
        },
        {
          text: "CAD"
        },
        {
          text: "KWD"
        },
        {
          text: "NOK"
        },
        {
          text: "SAR"
        },
        {
          text: "JPY"
        },
        {
          text: "BGN"
        },
        {
          text: "RON"
        },
        {
          text: "RUB"
        },
        {
          text: "IRR"
        },
        {
          text: "CNY"
        },
        {
          text: "PKR"
        },
        {
          text: "QAR"
        }
      ],
      kurList: [],
      paraBirimi: null,
      kur: 1,
      fkurtarihi: null,
    };
  },

  created: function () {},

  watch: {
    model(val) {
      this.watchmodel(val);
    }
  },

  methods: {
    kurChange: kurChange,
    paraBirimiChange: paraBirimiChange,
    paraAra: paraAra,
    paraAraTL: paraAraTL,
    getKur: getKur,
    watchmodel: watchmodel,
  }
};

function watchmodel(val) {

  if ((store.state.paraBirimleri.length == 0) || (store.okunuyor == false)) {
     var cred=JSON.parse(window.localStorage.getItem('credentials'));
     var pb=cred.ParaBirimi;
          if (pb=='TRY'){
            pb='TL';
          }
    store.okunuyor = true;
    tool
      .http_post(this, "ParaBirimleri", {
        paraBirimi: "",
        kur: "",
        kurTarihi: null
      })
      .then(
        response => {
          if (response.body.length == 0) {
            this.items = this.defitems;
          } else {
            this.items = response.body;

          }
          store.setParaBirimleri(this.items);
          this.kur = val.kur;
          this.paraBirimi = val.paraBirimi;
          
        },
        response => {
          this.items = this.defitems;
          this.kur = val.kur;
          this.paraBirimi = val.paraBirimi;
           
        }
      );
  } else {
    this.items = store.state.paraBirimleri;
    this.kur = val.kur;
    this.paraBirimi = val.paraBirimi;
  }

}

function paraAra(paraBirimi) {
  return paraBirimi.paraBirimi == this.paraBirimi;
}

function paraAraTL(paraBirimi) {
  return paraBirimi.paraBirimi == "TL";
}

function kurChange() {
  this.model.kur = this.kur;
}

function paraBirimiChange() {

  if (this.model.paraBirimi !== this.paraBirimi) {
    this.model.paraBirimi = this.paraBirimi;
  }

  if (this.fkurtarihi == null || this.kurtarihi != this.fkurtarihi) {
    this.fkurtarihi = this.kurtarihi;

    if (this.fkurtarihi == null)
      this.fkurtarihi = tool.Now_yyyy_MM_dd();


    tool.http_post(this, "KurAra", {
      tarih: this.fkurtarihi
    }).then(
      response => {
        this.kurList = response.body;
        this.getKur();
      },
      response => {
        this.model.kur = 1;
      }
    );
  } else {
    this.getKur();

  }
}

function getKur() {
  var p = this.kurList.find(this.paraAra);

  if (p == undefined) {
    this.kur = 1;
    this.model.kur = 1;
  } else {

    this.kur = p.kur;
    this.paraBirimi = p.paraBirimi;
    this.model.kur = p.kur;
  }

}
</script>
